import "./Header.css";

import {
    Search,
    ShoppingCart,
    User
} from "lucide-react";

function Header() {

    return (
        <header className="header">

            {/* =========================
                FarmFox Logo
            ========================= */}

            <div className="header__logo">

                <img
                    src="/logo_farmfox.jpeg"
                    alt="FarmFox"
                    className="farmfox-main-logo"
                />

                <span className="logo-tagline">
                    Premium Mithila Makhana
                </span>

            </div>


            {/* =========================
                Navigation
            ========================= */}

            <nav className="header__nav">

                <a href="/">
                    Shop
                    <span className="arrow">▼</span>
                </a>

                <a href="/">
                    Collections
                </a>

                <a href="/">
                    Best Sellers
                </a>

                <a href="/">
                    Combos
                </a>

                <a href="/">
                    Gift Boxes
                </a>

            </nav>


            {/* =========================
                Actions
            ========================= */}

            <div className="header__actions">

                {/* Search */}

                <div className="search-box">

                    <input
                        type="text"
                        placeholder="Search Premium Makhana..."
                    />

                    <Search size={18} />

                </div>


                {/* User */}

                <div className="icon-btn">

                    <User size={20} />

                </div>


                {/* Cart */}

                <button className="cart-btn">

                    <ShoppingCart size={18} />

                    <span>
                        Cart
                    </span>

                </button>

            </div>

        </header>
    );
}

export default Header;